// Defaults seeded into a freshly-created tenant so the owner can start
// booking immediately. Called from ShopRegister after insertTenant succeeds.
//
// This is now a thin wrapper over the 標準 setting template — see
// lib/settingTemplates.js for the actual data and for the other four
// templates the owner can switch to from the first-login wizard or from
// 設定 → 服務 → 套用設定模板.
//
// Why seed at all instead of making the first-login picker mandatory: an
// owner who registers and abandons the wizard would otherwise be left with
// a shop that has no services and cannot take a booking. 標準 is the safe
// default; swapping it later is non-destructive (services are matched by
// name and keep their ids, and nothing is ever deleted).
//
// All prices start at 0 — the owner fills them in. The structure (size
// tiers / special breeds / service list) is the time-saver.

import { applyTemplate, getTemplate } from "./settingTemplates";

// Synth email used for an auto-seeded staff account. Nothing creates one
// anymore (the owner's own profile is treated as bookable staff — see
// dataLoader.attachTenantChildren and api.fetchPublicTenantBundle, which
// both include role='owner' in tenant.staffIds), but the helper is still
// exported because existing shops have staff rows using this address shape.
export function synthStaffEmail(slug) {
  return "staff." + (slug || "shop") + "@petos.local";
}

// Best-effort seed: never throws — if any single insert fails we log and
// continue so the owner isn't blocked from entering the dashboard.
export async function seedTenantDefaults({ tenantId }) {
  try {
    const res = await applyTemplate({
      tenantId,
      // A brand-new tenant has no children yet, so there is nothing to match
      // against and nothing to carry prices over from.
      tenant: { pricingConfig: {}, specialBreeds: [], services: [], addons: [] },
      template: getTemplate("standard"),
      keepPrices: false,
      extraServices: "keep",
    });
    return { errors: res.errors || [] };
  } catch (e) {
    console.warn("[PettoBook seed] failed:", e);
    return { errors: ["seed:" + (e?.message || e)] };
  }
}
